import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgNextPage = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="12"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 12 12"
    >
        <g clipPath="url(#clip0)">
            <path
                d="M3.73879 0.0956182L9.22692 5.76937C9.28628 5.83147 9.31942 5.91408 9.31942 5.99999C9.31942 6.08591 9.28628 6.16851 9.22692 6.23062L3.73879 11.9044C3.71006 11.9347 3.67546 11.9588 3.6371 11.9753C3.59874 11.9918 3.55742 12.0003 3.51566 12.0003C3.47391 12.0003 3.43259 11.9918 3.39423 11.9753C3.35587 11.9588 3.32127 11.9347 3.29254 11.9044L2.77316 11.3681C2.7138 11.306 2.68066 11.2234 2.68066 11.1375C2.68066 11.0516 2.7138 10.969 2.77316 10.9069L7.50942 5.99999L2.77316 1.09312C2.7138 1.03102 2.68066 0.948409 2.68066 0.862494C2.68066 0.776578 2.7138 0.693973 2.77316 0.631868L3.29254 0.0956182C3.32127 0.065321 3.35587 0.041193 3.39423 0.024704C3.43259 0.00821495 3.47391 -0.000287056 3.51566 -0.000287056C3.55742 -0.000287056 3.59874 0.00821495 3.6371 0.024704C3.67546 0.041193 3.71006 0.065321 3.73879 0.0956182Z"
                fill="#373739"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect
                    fill="white"
                    height="12"
                    transform="translate(0 12) rotate(-90)"
                    width="12"
                />
            </clipPath>
        </defs>
    </svg>
);

export const NextPageIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgNextPage}
        fontSize={fontSize}
    />
);
